import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
      label: '公告标题',
      prop: 'title',
      search: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
      clearable: true
    },
    {
      label: '发布人',
      prop: 'issuer',
      search: false,
      searchSlot: false,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '可见范围',
      prop: 'visibleRange',
      search: false,
      searchSlot: false,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '已读',
      prop: 'readCount',
      search: false,
      searchSlot: false,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '未读',
      prop: 'noReadCount',
      search: false,
      searchSlot: false,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center'
    },
    {
      label: '状态',
      prop: 'status',
      search: true,
      clearable: true,
      type: "select",
      dicData: [
        {
          label: '未发布',
          value: 1
        },
        {
          label: '已发布',
          value: 2
        },
      ],
      formatter: function (row, value) {
        return value == 1 ? '未发布' : value == 2 ? '已发布' : ''
      }
    },
    {
      label: '发布时间',
      prop: 'createTime',
      search: true,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      type: 'datetimerange',
      viewDisplay: false,
      align: 'right',
      hide: false,
      span: 24,
      formatter: function (row, value) {
        return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
      }
    }
  ]
  }
}